import axios from "axios";
import { jwtDecode } from "jwt-decode";

const trimTrailingSlash = value => String(value || "").replace(/\/+$/, "");

const resolveApiUrl = () => {
  const fromReactEnv = trimTrailingSlash(process.env.REACT_APP_API_URL);
  if (fromReactEnv) {
    return fromReactEnv;
  }

  const fromLegacyEnv = trimTrailingSlash(process.env.API_BASE_URL);
  if (fromLegacyEnv) {
    return fromLegacyEnv;
  }

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://localhost:3000/prod";
    }
  }

  return "https://thegrovebing.com/prod";
};

const API_URL = resolveApiUrl();

export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Token decode error:", error);
    return true;
  }
};

export const getToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

export const getCurrentUserRole = () => {
  return String(
    sessionStorage.getItem("userRole") ||
    localStorage.getItem("userRole") ||
    ""
  ).toLowerCase();
};

export const getAllEvents = () => {
  return axios.get(`${API_URL}/events/getAllEvents`);
};

export const getAllMenu = () => {
  return axios.get(`${API_URL}/menu/getAllMenu`);
};
export const getAllReservation = () => {
  return axios.get(`${API_URL}/reservation/getReservationFull`);
};
export const getAllDrinkMenu = () => {
  return axios.get(`${API_URL}/drink-menu/getAllDrinkMenu`);
};
export const getAllHappyHourMenu = () => {
  return axios.get(`${API_URL}/happy-hour-menu/getAllHappyHourMenu`);
};
export const getAllBrunchMenu = () => {
  return axios.get(`${API_URL}/brunch-menu/getAllBrunchMenu`);
};
export const getAllMerch = () => {
  return axios.get(`${API_URL}/merch/getAllMerch`);
};

export const getCurrentUser = () => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.get(`${API_URL}/auth/me`, config);
};

export const getHomeContent = () => {
  return axios.get(`${API_URL}/home/getHomeContent`);
};

export const updateHomeHero = ({ heroSlides }) => {
  const token = getToken();
  const formData = new FormData();
  const sanitizedSlides = (heroSlides || []).map((slide, index) => {
    if (!slide) {
      return slide;
    }
    const { imageFile, imageName, ...rest } = slide;
    if (imageFile) {
      formData.append(`heroImage_${index}`, imageFile, imageFile.name);
    }
    return rest;
  });
  formData.append("heroSlides", JSON.stringify(sanitizedSlides));
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.put(`${API_URL}/home/updateHero`, formData, config);
};

export const addHomeHappening = ({
  day,
  title,
  details,
  time,
  imageFile,
  image,
}) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("day", day);
  formData.append("title", title);
  formData.append("time", time);
  formData.append("details", JSON.stringify(details || []));
  if (imageFile) {
    formData.append("image", imageFile, imageFile.name);
  } else if (image) {
    formData.append("image", image);
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(`${API_URL}/home/addHappening`, formData, config);
};

export const deleteHomeHappening = (happeningId) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.delete(
    `${API_URL}/home/deleteHappening/${happeningId}`,
    config
  );
};

export const updateHomeHappening = ({
  happeningId,
  day,
  title,
  details,
  time,
  imageFile,
  image,
}) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("day", day);
  formData.append("title", title);
  formData.append("time", time);
  formData.append("details", JSON.stringify(details || []));
  if (imageFile) {
    formData.append("image", imageFile, imageFile.name);
  } else if (image) {
    formData.append("image", image);
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.put(
    `${API_URL}/home/updateHappening/${happeningId}`,
    formData,
    config
  );
};

export const createEvent = (eventTitleName, eventDescription, eventAsset) => {
  const formData = new FormData();
  formData.append("eventTitleName", eventTitleName);
  formData.append("eventDescription", eventDescription);
  if (eventAsset) {
    console.log("eventAsset", eventAsset.name);
    formData.append("eventAsset", eventAsset, eventAsset.name);
  }

  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const rsp = axios.post(`${API_URL}/events/addEvent`, formData, config);
  console.log("rsp", rsp);
  return rsp;
};

export const updateEvents = (
  eventId,
  eventTitleName,
  eventDescription,
  eventAsset
) => {
  const formData = new FormData();
  const token = getToken();
  formData.append("eventTitleName", eventTitleName);
  formData.append("eventDescription", eventDescription);
  if (eventAsset) {
    console.log("eventAsset", eventAsset);
    formData.append("eventAsset", eventAsset, eventAsset.name);
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  console.log("formData", formData);
  return axios.put(`${API_URL}/events/${eventId}`, formData, config);
};

export const deleteEvents = (eventsId) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.delete(`${API_URL}/events/delete/${eventsId}`, config);
};

export const createMenu = (
  itemName,
  itemCategory,
  itemDescription,
  itemPrice,
  itemImage
) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("itemName", itemName);
  formData.append("itemCategory", JSON.stringify(itemCategory || []));
  formData.append("itemDescription", itemDescription);
  formData.append("itemPrice", itemPrice);
  if (itemImage) {
    formData.append("itemImage", itemImage, itemImage.name);
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(
    `${API_URL}/menu/addMenuItem`,
    formData,
    config
  );
};

export const createDrinkMenu = (
  itemName,
  itemCategory,
  itemDescription,
  itemPrice
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(
    `${API_URL}/drink-menu/addDrinkMenuItem`,
    {
      itemName,
      itemCategory,
      itemDescription,
      itemPrice,
    },
    config
  );
};

export const createHappyHourMenu = (
  itemName,
  itemCategory,
  itemDescription,
  itemPrice
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.post(
    `${API_URL}/happy-hour-menu/addHappyHourMenuItem`,
    {
      itemName,
      itemCategory,
      itemDescription,
      itemPrice,
    },
    config
  );
};

export const createBrunchMenu = (
  itemName,
  itemCategory,
  itemDescription,
  itemPrice
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(
    `${API_URL}/brunch-menu/addBrunchMenuItem`,
    {
      itemName,
      itemCategory,
      itemDescription,
      itemPrice,
    },
    config
  );
};

export const createMerch = (itemName, itemPrice, itemImage) => {
  const token = getToken();

  const formData = new FormData();
  formData.append("itemName", itemName);
  formData.append("itemPrice", itemPrice);
  if (itemImage) {
    formData.append("itemImage", itemImage, itemImage.name);
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.post(`${API_URL}/merch/addMerchItem`, formData, config);
};

export const updateMenu = (
  menuId,
  itemName,
  itemCategory,
  itemDescription,
  itemPrice,
  itemImage
) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("itemName", itemName);
  formData.append("itemCategory", JSON.stringify(itemCategory || []));
  formData.append("itemDescription", itemDescription);
  formData.append("itemPrice", itemPrice);
  if (itemImage) {
    formData.append("itemImage", itemImage, itemImage.name);
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.put(
    `${API_URL}/menu/updateMenuItem/${menuId}`,
    formData,
    config
  );
};

export const updateDrinkMenu = (
  menuId,
  itemName,
  itemCategory,
  itemDescription,
  itemPrice
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.put(
    `${API_URL}/drink-menu/updateDrinkMenuItem/${menuId}`,
    {
      itemName,
      itemCategory,
      itemDescription,
      itemPrice,
    },
    config
  );
};

export const updateHappyHourMenu = (
  menuId,
  itemName,
  itemCategory,
  itemDescription,
  itemPrice
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.put(
    `${API_URL}/happy-hour-menu/updateHappyHourMenuItem/${menuId}`,
    {
      itemName,
      itemCategory,
      itemDescription,
      itemPrice,
    },
    config
  );
};

export const updateBrunchMenu = (
  menuId,
  itemName,
  itemCategory,
  itemDescription,
  itemPrice
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.put(
    `${API_URL}/brunch-menu/updateBrunchMenuItem/${menuId}`,
    {
      itemName,
      itemCategory,
      itemDescription,
      itemPrice,
    },
    config
  );
};

export const updateMerch = (merchId, itemName, itemPrice, itemImage) => {
  const token = getToken();

  const formData = new FormData();
  formData.append("itemName", itemName);
  formData.append("itemPrice", itemPrice);
  if (itemImage) {
    formData.append("itemImage", itemImage, itemImage.name);
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.put(`${API_URL}/merch/updateMerchItem/${merchId}`, formData, config);
};

export const deleteMenu = (menuId) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.delete(`${API_URL}/menu/delete/${menuId}`, config);
};

export const deleteDrinkMenu = (menuId) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.delete(`${API_URL}/drink-menu/delete/${menuId}`, config);
};

export const deleteHappyHourMenu = (menuId) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.delete(`${API_URL}/happy-hour-menu/delete/${menuId}`, config);
};

export const deleteBrunchMenu = (menuId) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.delete(`${API_URL}/brunch-menu/delete/${menuId}`, config);
};

export const deleteMerch = (merchId) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.delete(`${API_URL}/merch/delete/${merchId}`, config);
};

export const addReservation = (
  reservationDateOrPayload,
  reservationFull,
  reservationLimit,
  reservationTime
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const payload =
    reservationDateOrPayload &&
    typeof reservationDateOrPayload === "object" &&
    !Array.isArray(reservationDateOrPayload)
      ? reservationDateOrPayload
      : {
          reservationDate: reservationDateOrPayload,
          reservationFull,
          reservationLimit,
          reservationTime,
        };

  return axios.post(
    `${API_URL}/reservation/addReservationFull`,
    payload,
    config
  );
};

export const deleteReservation = (reservationId) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.delete(
    `${API_URL}/reservation/deleteReservationFull/${reservationId}`,
    config
  );
};

export const updateReservation = (
  reservationId,
  reservationDateOrPayload,
  reservationFull,
  reservationLimit,
  reservationTime
) => {
  const token = getToken();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const payload =
    reservationDateOrPayload &&
    typeof reservationDateOrPayload === "object" &&
    !Array.isArray(reservationDateOrPayload)
      ? reservationDateOrPayload
      : {
          reservationDate: reservationDateOrPayload,
          reservationFull,
          reservationLimit,
          reservationTime,
        };

  return axios.put(
    `${API_URL}/reservation/updateReservationFull/${reservationId}`,
    payload,
    config
  );
};

export const getReservationSettings = () => {
  return axios.get(`${API_URL}/reservation-settings/getReservationSettings`);
};

export const updateReservationSettings = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.put(`${API_URL}/reservation-settings/updateReservationSettings`, payload, config);
};

export const getStaffReservations = (params = {}) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  };
  return axios.get(`${API_URL}/reservations/staff/all`, config);
};

export const createStaffReservation = payload => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(`${API_URL}/reservations`, payload, config);
};

export const updateStaffReservationStatus = (reservationId, payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.patch(
    `${API_URL}/reservations/staff/${encodeURIComponent(reservationId)}/status`,
    payload,
    config
  );
};

export const updateStaffReservation = (reservationId, payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.patch(
    `${API_URL}/reservations/staff/${encodeURIComponent(reservationId)}`,
    payload,
    config
  );
};

export const deleteStaffReservation = reservationId => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.delete(
    `${API_URL}/reservations/staff/${encodeURIComponent(reservationId)}`,
    config
  );
};

export const getMenuCategories = (type) => {
  const config = type ? { params: { type } } : undefined;
  return axios.get(`${API_URL}/menu-categories`, config);
};

export const createMenuCategory = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(`${API_URL}/menu-categories`, payload, config);
};

export const updateMenuCategory = (categoryIdOrPayload, payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const categoryId =
    typeof categoryIdOrPayload === "string"
      ? categoryIdOrPayload
      : categoryIdOrPayload?.categoryId;

  const body =
    typeof categoryIdOrPayload === "string"
      ? payload
      : { ...categoryIdOrPayload, categoryId: undefined };

  return axios.put(`${API_URL}/menu-categories/${categoryId}`, body, config);
};

// Backward-compatible alias used by older views.
export const addMenuCategory = createMenuCategory;

export const deleteMenuCategory = (categoryId) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.delete(`${API_URL}/menu-categories/${categoryId}`, config);
};

export const getGameSpecials = () => {
  return axios.get(`${API_URL}/game-specials/getGameSpecials`);
};

export const updateGameSpecials = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.put(`${API_URL}/game-specials/updateGameSpecials`, payload, config);
};

export const getAuditLogs = (params = {}) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  };
  return axios.get(`${API_URL}/audit-logs`, config);
};

export const getBlackCard = () => {
  return axios.get(`${API_URL}/black-card/getBlackCard`);
};

export const updateBlackCard = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.put(`${API_URL}/black-card/updateBlackCard`, payload, config);
};

export const getSkyLounge = () => {
  return axios.get(`${API_URL}/sky-lounge/getSkyLounge`);
};

export const updateSkyLounge = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.put(`${API_URL}/sky-lounge/updateSkyLounge`, payload, config);
};

export const getPrivateBooking = () => {
  return axios.get(`${API_URL}/private-booking/getPrivateBooking`);
};

export const updatePrivateBooking = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.put(`${API_URL}/private-booking/updatePrivateBooking`, payload, config);
};

export const sendNotificationToAll = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(`${API_URL}/notifications/sendAll`, payload, config);
};


export const getStaffOrders = (status = "") => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: status ? { status } : {},
  };
  return axios.get(`${API_URL}/orders/staff/all`, config);
};

export const updateStaffOrderStatus = (orderNumber, status) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.patch(
    `${API_URL}/orders/staff/${encodeURIComponent(orderNumber)}/status`,
    { status },
    config
  );
};

export const requeueOrderPrintJob = (orderNumber) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(`${API_URL}/print-jobs/orders/${encodeURIComponent(orderNumber)}/requeue`, {}, config);
};

export const queueTestPrint = (payload) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(`${API_URL}/print-jobs/staff/test-print`, payload, config);
};

export const getPrinterAgentStatuses = () => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.get(`${API_URL}/print-jobs/staff/agents`, config);
};

export const getPrintAgentLogs = (params = {}) => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  };
  return axios.get(`${API_URL}/print-jobs/staff/logs`, config);
};

export async function login(email, password) {
  try {
    const response = await axios.post(`${API_URL}/auth/admin-login`, {
      email,
      password,
    });
    const role = String(response.data?.role || "").toLowerCase();
    if (!["admin", "employee"].includes(role)) {
      throw new Error("Only admin and employee accounts can access this portal.");
    }

    sessionStorage.setItem("token", response.data.token);
    if (email) {
      sessionStorage.setItem("userEmail", email);
      const localPart = email.split("@")[0];
      if (localPart) {
        sessionStorage.setItem("userName", localPart);
      }
    }
    if (response.data.username) {
      sessionStorage.setItem("userName", response.data.username);
    }
    if (role) {
      sessionStorage.setItem("userRole", role);
    }
    return response.data;
  } catch (error) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userRole");
    console.error("Error checking if user is logged in", error);
    throw error;
  }
}

export const logout = (history) => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("userEmail");
  sessionStorage.removeItem("userName");
  sessionStorage.removeItem("userRole");
  history.push("/auth/sign-in");
};

export const getImageUrl = (relativePath) => {
  return `${API_URL}/${relativePath}`;
};

// Backward-compatible aliases used by legacy admin screens.
export const createReservationFull = addReservation;
export const updateOrderStatus = updateStaffOrderStatus;
